export default __webpack_public_path__ + "static/media/orgtconnect-background.9ab358bf.jpg";